<div class="audio-playback">
    <ui-button type="ghost" size="no-padding">
        <mat-icon svgIcon="playback" (click)="onPlay($event)"></mat-icon>
    </ui-button>
    <audio #audio></audio>
</div>
